<template>
  <div>
    <AppTextField v-model.trim="model.$model"
                  :label="$t('common.birthName')"
                  :error-messages="birthNameErrors"
                  :error="isErrored"
    >
      <template #append-inner>
        <AppTooltip location="bottom" max-width="300">
          <template #activator="{ props }">
            <font-awesome-icon :icon="['far', 'circle-question']"
                               class="clickable mr-2"
                               v-bind="props"
            />
          </template>
          <v-img src="@/assets/img/profile/id_example_last_name.png" width="300" />
        </AppTooltip>
      </template>
    </AppTextField>

    <AppTextFieldSuggestion v-if="displaySuggestedValue"
                            :suggestedValue="suggestedValue"
                            @validate="model.$model = suggestedValue"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import AppTooltip from '@/common/AppTooltip.vue'
import AppTextFieldSuggestion from '@/common/identity-checking/AppTextFieldSuggestion.vue'
import { formFieldErrors } from '@/common/utils/form'
import { ID_CHECK_ERRORS } from '@/common/utils/idCheckErrors'

export default {
  name: 'BirthName',
  components: { AppTextField, AppTextFieldSuggestion, AppTooltip },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['idCheckError']),
    ...mapGetters('user', ['hasIdCheckErrorInfo']),
    birthNameErrors () {
      return formFieldErrors(
        this.model,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('common.birthName') })],
        ],
      )
    },
    isErrored () {
      return this.hasIdCheckErrorInfo &&
        this.idCheckError.errors.includes(ID_CHECK_ERRORS.ERROR_BIRTHNAME_MISMATCH) &&
        this.displaySuggestedValue
    },
    suggestedValue () {
      return this.idCheckError?.suggestedValues?.birthName
    },
    displaySuggestedValue () {
      return this.suggestedValue && this.suggestedValue !== this.model.$model
    },
  },
}
</script>
